import request from '@/utils/request.js'
import qs from 'qs';

export function sysRequest(url, data, method){
    let obj = {};
    if(method=="get"){
    	obj = {
    		url: url,
    		method: method,
    		params: data,
    	}
    }else if(method=="post"){
    	obj = {
    		url,
    		method,
    		data,
    	}
    }
    return request(obj)
}